# GraphQL query to get all the emails for a given stage

#import "../fragments/email-automation.graphql"

query EmailsForStagesetQuery($stagesetId: ID!) {
    stageset(id: $stagesetId) {
        id
        editableProcessTemplate {
            emailAutomations {
                ...EmailAutomation
            }
        }
    }
    hasMailChimpIntegration
}
